import { ApolloLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

import { toast } from 'react-hot-toast'

import { setAircraftId } from './slices/auditLog'
import store from './store'
import { findNested } from './utils/helpers'

const CustomApolloLink = (redwoodApolloLinks) => {
  const customRequestHeadersLink = new ApolloLink((operation, forward) => {
    operation.setContext((oldContext) => {
      const headers = { ...oldContext.headers }

      //add aircraftId as header to the request for BE permit checks (both queries and mutations) and audit log (mutations only)
      // Only add the aircraft-id header if it is not already set like for reviseComplianceLedger
      if (!oldContext?.headers?.['aircraft-id']) {
        const aircraftIdFromPayload = findNested(
          operation.variables,
          'aircraftId'
        )
        // from redux store
        const aircraftIdFromRedux = store.getState().auditLog.aircraftId

        // If the aircraftId is in the payload, set it in the redux store
        if (aircraftIdFromPayload && aircraftIdFromRedux === '') {
          store.dispatch(setAircraftId(aircraftIdFromPayload))
        }

        return {
          ...oldContext,
          headers: {
            ...headers,
            'aircraft-id': aircraftIdFromPayload ?? aircraftIdFromRedux,
          },
        }
      }

      // For other operations, return the old context with CORS headers if set
      return {
        ...oldContext,
        headers,
      }
    })

    return forward(operation)
  })

  const errorLink = onError(({ operation, graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.forEach(({ message, locations, path, extensions }) => {
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )

        const isMutation = operation.query.definitions.some(
          (definition) =>
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation'
        )
        if (isMutation && extensions?.code === 'FORBIDDEN') {
          toast.error(message)
        }
      })
    if (networkError) {
      // browser is offline check
      if (window !== undefined && !window.navigator.onLine) {
        toast.error('Unable to make request. Check your internet connection.')
      }

      if (networkError.name === 'AbortError') {
        return
      }
      console.error(
        `[Network error]: ${operation.operationName} ${networkError}`
      )
    }
  })

  return ApolloLink.from([
    errorLink,
    customRequestHeadersLink,
    ...redwoodApolloLinks.map(({ link }) => link),
  ])
}

export default CustomApolloLink
